import {
  TimeTracking,
  TimeTrackingDayEntry,
} from 'src/tabs/models/TimesheetsInterface';
import { TimeSheetsTableBodyCell } from '../Cells/TimesheetsTableBodyCell';
import { getWeeklyHours } from '../utils/getSumHours';
import { TableRowBody } from './styles/TimesheetsBodyRow.styled';

interface TimeSheetsBodyRowProps {
  assignmentData: TimeTracking;
  assignmentType: number;
  getAssignments: () => void;
  anyPopupsOpen: boolean;
  setAnyPopupsOpen: (value: boolean) => void;
}

const ASSIGNMENT_NON_BILLABLE_PROJECT_TYPE = 100_000_001;

export const TimesheetsBodyRow = ({
  assignmentData,
  assignmentType,
  getAssignments,
  anyPopupsOpen,
  setAnyPopupsOpen,
}: TimeSheetsBodyRowProps) => {
  const weeklyHours = getWeeklyHours(assignmentData);

  return (
    <TableRowBody>
      <TimeSheetsTableBodyCell title={assignmentData.assignment.new_title} />
      {assignmentData.dayEntries.map(
        (dayEntryData: TimeTrackingDayEntry, index) => {
          return (
            <TimeSheetsTableBodyCell
              assignmentId={assignmentData.assignment.new_axsassignmentid}
              assignment={assignmentData.assignment}
              timeTrackingId={dayEntryData?.new_axstimetrackingdayentryid}
              description={dayEntryData?.new_description}
              date={dayEntryData?.new_date}
              hours={dayEntryData?.new_actualhours || null}
              forecastedHours={dayEntryData?.new_forecastedsupplyallocation}
              assignmentType={assignmentType}
              statecode={dayEntryData?.statecode}
              status={dayEntryData?.statuscode}
              dayType={dayEntryData?.new_daytype}
              showHourPills={
                assignmentType <= ASSIGNMENT_NON_BILLABLE_PROJECT_TYPE &&
                dayEntryData?.new_daytype < ASSIGNMENT_NON_BILLABLE_PROJECT_TYPE
              }
              index={index}
              key={dayEntryData.new_axstimetrackingdayentryid}
              getAssignments={getAssignments}
              anyPopupsOpen={anyPopupsOpen}
              setAnyPopupsOpen={setAnyPopupsOpen}
            />
          );
        }
      )}
      <TimeSheetsTableBodyCell weeklyHours={weeklyHours} index={7} />
    </TableRowBody>
  );
};
